export default __webpack_public_path__ + "static/media/004-pear.34876897.svg";